import {Editable} from '../components/Editable';
import {arNum, formatWhen, projectStatus, STATUS_LABEL} from '../format';
import {useStudio} from '../store';
import type {Aspect} from '../types';

const ASPECTS: Aspect[] = ['9:16', '16:9', '1:1'];

const PLACEHOLDER =
  'اكتب فكرة الفيديو بجملة أو أكثر — عن ماذا يتحدث؟';

export function BriefScreen() {
  const s = useStudio();
  const creating = s.isBusy('create');
  const error = s.errorFor('create');

  return (
    <main className="brief-screen">
      <div className="hero">
        <h1>استوديو الفيديو الذكي</h1>
        <div className="hero-sub">
          <i />
          <span>من موجز مكتوب إلى فيديو اجتماعي جاهز للنشر</span>
          <i />
        </div>
      </div>

      <div className="panel" style={{marginTop: 40}}>
        <div className="panel-head">
          <span className="h-title">فكرة الفيديو</span>
          <span className="h-note">اكتب بحرية — سنتولى التفكيك إلى مشاهد</span>
        </div>
        <Editable
          id="brief-input"
          className="brief-body"
          value={s.brief}
          placeholder={PLACEHOLDER}
          onInput={s.setBrief}
          onCommit={s.setBrief}
        />
        <div className="brief-foot">
          <div className="foot-group">
            <span>نسبة العرض</span>
            <div className="seg">
              {ASPECTS.map((a) => (
                <button
                  key={a}
                  type="button"
                  className={s.aspect === a ? 'on' : ''}
                  onClick={() => s.setAspect(a)}
                >
                  {a}
                </button>
              ))}
            </div>
          </div>
          <div className="foot-group">
            <span>المدة المستهدفة</span>
            <div className="stepper">
              <button type="button" onClick={() => s.adjustDuration(-5)} aria-label="أقل">
                −
              </button>
              <span>{arNum(s.duration)} ثانية</span>
              <button type="button" onClick={() => s.adjustDuration(5)} aria-label="أكثر">
                +
              </button>
            </div>
          </div>
          <div className="grow" />
          <button type="button" className="btn lg" disabled={creating} onClick={() => void s.create()}>
            {creating ? (
              <>
                <span className="spin" style={{width: 15, height: 15}} />
                جاري الإنشاء…
              </>
            ) : (
              'أنشئ الفيديو'
            )}
          </button>
        </div>
        {error && (
          <div style={{padding: '0 22px 16px'}}>
            <span className="err-note">{error}</span>
          </div>
        )}
      </div>

      <div style={{marginTop: 56}} id="recent">
        <div className="sec-head">
          <span className="chip solid">مشاريعي</span>
          <span className="rule-line" />
          <a onClick={() => void 0}>{arNum(s.projects.length)} مشروع</a>
        </div>
        {s.projects.length === 0 ? (
          <p className="empty-note" style={{padding: '14px 4px'}}>
            لا توجد مشاريع بعد — اكتب موجزًا أعلاه لتبدأ.
          </p>
        ) : (
          s.projects.map((p) => {
            const status = projectStatus(p.status);
            const opening = s.isBusy(`open:${p.id}`);
            const isRendered = p.status === 'rendered';
            return (
              <div key={p.id} className="proj-card">
                <button
                  type="button"
                  className="proj"
                  disabled={opening}
                  onClick={() => void s.open(p.id)}
                >
                  <div className="proj-mark">{p.title.trim()[0] ?? '؟'}</div>
                  <div style={{flex: 1, minWidth: 0}}>
                    <div className="proj-t">{p.title}</div>
                    <div className="proj-m">
                      <span>{formatWhen(p.created_at)}</span>
                      <span className="util-sep" />
                      <span>
                        {arNum(p.target_duration_s)} ثانية · {p.aspect_ratio}
                      </span>
                    </div>
                  </div>
                  {opening ? (
                    <span className="spin" style={{width: 14, height: 14}} />
                  ) : (
                    <span className={`chip ${status}`}>{STATUS_LABEL[status]}</span>
                  )}
                </button>
                {isRendered && (
                  <div className="proj-actions">
                    <button
                      type="button"
                      className="btn-out xs"
                      onClick={() => void s.open(p.id).then(() => s.go('preview'))}
                    >
                      ▶ شاهد وقم بتحميل
                    </button>
                    <button
                      type="button"
                      className="btn-txt"
                      onClick={() => void s.open(p.id)}
                    >
                      تفاصيل المشروع
                    </button>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </main>
  );
}
